module.exports = __webpack_public_path__ + "static/tasa-64e7df4c786918ff6b8f2994a17eb6ac.png";